/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalBodyLayout from '../shared/ModalBodyLayout';
import { removeWhitespaces } from '../../utilities/helpers';

const EnterAccountPassword = ({ setPassword, getDetails, isLoadingDetails }) => {
  const { t: translate } = useTranslation();

  const [password, changePassword] = useState('');

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    getDetails();
    return true;
  };

  const handleChange = (e) => {
    if (!e) return;
    if (!e.target) {
      changePassword(removeWhitespaces(e));
      setPassword(removeWhitespaces(e));
    } else {
      const { value } = e.target;
      changePassword(removeWhitespaces(value));
      setPassword(removeWhitespaces(value));
    }
  };

  const revealPassword = (e) => {
    const inputGroup = e.currentTarget.parentNode;
    const input = inputGroup.childNodes[0];
    if (input.type === 'password') {
      input.type = 'text';
      e.target.className = e.target.className.replace('open', 'close');
    } else if (input.type === 'text') {
      input.type = 'password';
      e.target.className = e.target.className.replace('close', 'open');
      e.target.style.top = '';
    }
  };

  const clearError = (e) => {
    e.target.className = e.target.className.replace('has-error', '');
  };

  return (
    <ModalBodyLayout
      withBack={false}
      isButtonInFooter
      renderHeader={() => (
        <div className="flex-row-center w-100">
          <b className="text-f5 text-dark">{translate('card_details_setting_title')}</b>
        </div>
      )}>
      <div className="mt-4">
        <p className="text-f5 text-dark p-0">{translate('card_details_setting_subtitle')}</p>
      </div>
      <form onSubmit={handleSubmitForm}>
        <div className="form-group m-0 mt-3">
          <input
            type="password"
            className="form-control-input"
            placeholder={translate('enter_password_placeholder')}
            name="password"
            value={password}
            onChange={handleChange}
            onFocus={clearError}
            required
          />
          <label className="floating-label">{translate('enter_password_placeholder')}</label>
          <label className="error-label">{translate('password_input_error_label')}</label>
          <span
            className="icon icon-open-icon h4"
            role="button"
            onClick={revealPassword}
            onKeyDown={null}
            tabIndex={-1}
            aria-label={translate('label_reveal_pin')}
          />
        </div>

        <div className="d-flex justify-content-center bottom-0 position-relative mt-5 w-100">
          <button
            type="submit"
            disabled={!password}
            loading={isLoadingDetails ? 'true' : 'false'}
            className="btn py-3 w-100 btn-primary">
            {translate('confirm_button_label')}
          </button>
        </div>
      </form>
    </ModalBodyLayout>
  );
};

export default EnterAccountPassword;

EnterAccountPassword.propTypes = {
  setPassword: PropTypes.func.isRequired,
  getDetails: PropTypes.func.isRequired,
  isLoadingDetails: PropTypes.bool.isRequired,
};
